// extracted by mini-css-extract-plugin
export default {"contentContainer":"OrderFormDetailsView_contentContainer__DefNW","content":"OrderFormDetailsView_content__fHTc0"};